<template>
  <div class="card">
    <loader v-if="dataLoading" style="z-index: 1101" />

    <div v-if="!hideControls" class="formgrid grid align-items-center">
      <div class="field col-12 xl:col-7">
          <MultiSelect v-model="selectedClients" :options="clients" :filter="true"  :filterFields="['cliente', 'rappresentante']" optionLabel="cliente" placeholder="Seleziona cliente" class='inputfield w-full'>
            <template #option="slotProps">
                <div class="flex align-items-center">
                    <div>{{ slotProps.option.cliente }} ({{slotProps.option.num_dilazioni}}) - {{slotProps.option.rappresentante}}</div>
                </div>
            </template>
            <template #footer>
                <div class="py-2 px-3">
                    <b>{{ selectedClients ? selectedClients.length : 0 }}</b> client{{ (selectedClients ? selectedClients.length : 0) > 1 ? 'i' : 'e' }} selezionati.
                </div>
            </template>
          </MultiSelect>
      </div>
      <div class="field col-9 xl:col-3 flex align-items-center justify-content-center">
        Dilazioni attive
        <InputSwitch class="m-2" v-model="view_all" @change="getClientHasDilazioni()"/>
        Tutte le dilazioni
      </div>
      <div class="field col-3 xl:col-2">
        <Button icon="pi pi-search" @click="getAllDilazioni" class="w-full" label="Cerca"/>
      </div>
    </div>
    <accordion :multiple="true">
      <accordion-tab v-for="dilazione of data.filtered" :key="dilazione.id">
        <template #header>
          <!-- <i v-if="dilazione.stato == 0" class="pi pi-times mr-1" style="color: red"></i>
          <i v-if="dilazione.stato == 1" class="pi pi-check mr-1" style="color: green"></i> -->
          <span>{{ dilazione.cliente.ragsoc }} - Numero rate: {{ dilazione.numero_rate }} - Totale dilazione: {{ currencyFormatter.format( dilazione.importo ) }} - Importo pagato: {{ currencyFormatter.format( dilazione.pagato ) }} - Data creazione: {{ moment(dilazione.data_creazione).format('DD/MM/YYYY') }}</span>
        </template>

        <div class="formgrid grid">
          <div class="field col-12 flex align-items-end">
            <label class="mr-2 mb-3">Stato:</label>
            <h4 :style="`color: ${dilazione.color}; font-weight: 600`">{{ dilazione.name_state }}</h4>
          </div>
          <div class="field col-12 md:col-4">
            <label for="data_creazione" class="mr-2">Data creazione</label>
            <calendar 
              id="data_creazione"
              v-model="dilazione.data_creazione" 
              :showIcon="true" 
              dateFormat="dd/mm/yy" 
              :disabled="true" 
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="importo" class="mr-2">Importo Dilazione</label>
            <input-number 
              id="importo" 
              v-model="dilazione.importo" 
              mode="currency" 
              currency="EUR" 
              locale="it-IT" 

              :disabled="true" 
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="numero_rate" class="mr-2">Numero Rate</label>
            <prime-input-text 
              id="numero_rate" 
              v-model="dilazione.numero_rate" 

              type="text" 

              :disabled="true" 
              class="inputfield w-full" 
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="ragsoc" class="mr-2">Cliente</label>
            <router-link  :to="`/ask/clienti/${dilazione.cliente.id}/dettagli`"
              custom
              v-slot="{ href }"
            >
              <prime-button 
                :label="`${dilazione.cliente.ragsoc}`" 
                class="p-button-info p-button-text w-full"
                @click="navigateToTab(href)" 
              />
            </router-link>
          </div>
          <div class="field col-12 md:col-8">
            <label for="pagato" class="mr-2">Importo Pagato</label>
            <input-number 
              id="pagato" 
              v-model="dilazione.pagato" 
              
              mode="currency" 
              currency="EUR" 
              locale="it-IT" 

              :disabled="true" 
              class="inputfield w-full" 
            />
          </div>

          <accordion :multiple="true" class="w-full">
            <accordion-tab header="Rate">
              <data-table :value="dilazione.rate" responsiveLayout="scroll">
                <column field="data" header="Data Pagamento">
                  <template #body="{data}">
                    {{ (data.data !== null)? moment(data.data).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="importo" header="Importo">
                  <template #body="{data}">
                    {{ currencyFormatter.format( (data.importo !== null)? data.importo: 0 ) }}
                  </template>
                </column>
                <column field="isPagato" header="Pagata">
                  <template #body="{data}">
                    {{ (data.isPagato)? 'SI' : 'NO' }}
                  </template>
                </column>
              </data-table>
            </accordion-tab>
          
            <accordion-tab header="Fatture">
              <data-table :value="dilazione.fatture" responsiveLayout="scroll">
                <column field="numero" header="Numero"></column>
                <column field="data_emissione" header="Data Emissione">
                  <template #body="{data}">
                    {{ (data.data !== null)? moment(data.data_emissione).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="data_scadenza" header="Data Scadenza">
                  <template #body="{data}">
                    {{ (data.data !== null)? moment(data.data_scadenza).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="totale_fattura" header="Totale Fattura">
                  <template #body="{data}">
                    {{ currencyFormatter.format( (data.totale_fattura !== null)? data.totale_fattura: 0 ) }}
                  </template>
                </column>
                <column field="saldo" header="Saldo">
                  <template #body="{data}">
                    {{ currencyFormatter.format( (data.saldo !== null)? data.saldo: 0 ) }}
                  </template>
                </column>
              </data-table>

            </accordion-tab>
          </accordion>
        </div>

        <Fieldset legend="Firma OTP" :toggleable="true">
          <prime-button v-if="!dilazione.cod_richiesta_firma"
          label="Richiedi firma dilazione" 
          icon="pi pi-send" 
          class="p-ml-auto m-1"
          @click="openDetailSignDilazione(dilazione.id)"
          :disabled="isDisableSignPdf"
          />

          <div v-else class="flex flex-wrap justify-content-around">
            <div class="col-12 flex h-4rem">
              <div class="col-4 flex justify-content-center" v-if="dilazione.data_annullamento">
                <InlineMessage severity="error">Documento annullato</InlineMessage>
              </div>
              <div class="col-4 flex justify-content-center" v-else-if="!dilazione.is_complete">
                <InlineMessage severity="info">Documento in attesa di firma</InlineMessage>
              </div>
              <div class="col-4 flex justify-content-center" v-else>
                <InlineMessage severity="success">Documento firmato</InlineMessage>
              </div>
              <div class="col-2"></div>
              <div class="col-6 flex flex-wrap justify-content-end">
                <prime-button v-if="dilazione.data_firma"
                  label="Scarica documento" 
                  icon="pi pi-download" 
                  class="p-ml-auto m-1 p-button-success"
                  @click="downloadPdf(dilazione.id)"
                />
                <prime-button v-if="dilazione.data_firma"
                  label="Scarica report di firma" 
                  icon="pi pi-download" 
                  class="p-ml-auto m-1 p-button-success"
                  @click="downloadPdf(dilazione.id, 'report')"
                />
                <prime-button v-if="!dilazione.data_annullamento && !dilazione.data_firma"
                  label="Annulla firma dilazione" 
                  icon="pi pi-trash" 
                  class="p-ml-auto m-1 p-button-danger"
                  @click="openConfirmDeleteSignDilazione(dilazione.id)"
                  :disabled="isDisableDeleteSign"
                  />
              </div>
            </div>
            <Fieldset legend="Dettagli" class="w-full">
              <div class="flex flex-wrap justify-content-around">
                <div>
                  <label>Nominativo di firma</label>
                  <h6>{{ dilazione.nominativo }}</h6>
                </div>
                <div>
                  <label>Contatto di firma</label>
                  <h6>{{ dilazione.contatto }}</h6>
                </div>
                <div>
                  <label>Email di firma</label>
                  <h6>{{ dilazione.email_firma }}</h6>
                </div>
                <div>
                  <label>{{ dilazione.stato_documento }} il</label>
                  <h6>{{ moment(getDataStatusDilazione(dilazione)).format('DD/MM/YYYY HH:mm') }}</h6>
                </div>
              </div>
            </Fieldset>
          </div>
        </Fieldset>

        <div class="flex p-3 pl-0">
          <prime-button 
            label="Cancella Dilazione" 
            icon="pi pi-file-o" 
            class="p-ml-auto m-1 p-button-danger"
            @click="confirmDelete($event, dilazione.id)"
            />

          <prime-button 
            label="Scarica XML RID" 
            icon="pi pi-file-o" 
            class="p-ml-auto m-1"
            @click="onXmlRidDilazione(dilazione.id)" 
          />

          <prime-button 
            label="Bollettini Postali" 
            icon="pi pi-file-o" 
            class="p-ml-auto m-1"
            @click="onBollettiniPostaliDilazione(dilazione.id)" 
          />

          <prime-button 
            label="Invia bollettini postali" 
            icon="pi pi-send" 
            class="p-ml-auto m-1"
            @click="openDialogInviaBollettiniPostali(dilazione)" 
          />

          <prime-button 
            label="PDF Lettera Accettazione" 
            icon="pi pi-download" 
            class="p-ml-auto m-1"
            @click="onPdfLetteraAccettazioneDilazione(dilazione.id)" 
          />

          <prime-button 
            label="Invia Mail PDF Lettera Accettazione" 
            icon="pi pi-send" 
            class="p-ml-auto m-1"
            @click="openDialogMailDilazioni(dilazione)" 
          />
        </div>
        <div class="flex p-3 pl-0">
          <prime-button v-if="dilazione.active != -1"
          label="Archivia dilazione" 
          icon="pi pi-cloud-upload" 
          class="p-ml-auto m-1 p-button-danger"
          @click="changeStatusDilazione(dilazione, -1)" 
          />
          <prime-button v-if="dilazione.active != 0"
            label="Attiva dilazione" 
            icon="pi pi-cloud-upload" 
            class="p-ml-auto m-1 p-button-success"
            @click="changeStatusDilazione(dilazione, 0)" 
          />
          <prime-button v-if="dilazione.active != 1"
            label="Salda dilazione" 
            icon="pi pi-cloud-upload" 
            class="p-ml-auto m-1"
            @click="changeStatusDilazione(dilazione, 1)" 
          />
        </div>
      </accordion-tab>
    </accordion>
  </div>

  <!-- Dialog invio bollettini postali -->
  <Dialog v-model:visible="dialogInviaBollettiniPostali" modal header="Invia bollettini postali" :style="{ width: '40rem' }">
    <div v-if="tempBollettiniPostali" class="formgrid grid">
      <div class="field col-12">
        <label class="mr-2">Destinatario</label>
        <InputText
          v-model="tempBollettiniPostali.email"
          class="w-full"
          placeholder="email@cliente.it"
        />
      </div>
      <div class="field col-12">
        <label class="mr-2">Oggetto</label>
        <InputText
          :modelValue="tempBollettiniPostali.oggetto"
          class="w-full"
          disabled
        />
      </div>
      <div class="field col-12">
        <label class="mr-2">Contenuto email</label>
        <div class="p-3 border-1 surface-border border-round surface-ground" style="white-space: pre-line; line-height: 1.5;">
          {{ tempBollettiniPostali.body }}
        </div>
      </div>
      <div class="field col-12">
        <label class="mr-2">Allegato</label>
        <p class="m-0">ZIP con {{ tempBollettiniPostali.num_bollettini }} bollettino/i postali (uno per rata)</p>
      </div>
    </div>
    <template #footer>
      <Button label="Annulla" icon="pi pi-times" @click="dialogInviaBollettiniPostali = false" class="p-button-text p-button-secondary"/>
      <Button
        label="Conferma invio"
        icon="pi pi-check"
        class="p-button-text"
        :disabled="!tempBollettiniPostali?.email || sendingBollettiniPostali"
        :loading="sendingBollettiniPostali"
        @click="confirmInviaBollettiniPostali"
      />
    </template>
  </Dialog>

  <!-- Dialog send dilazioni mail -->
  <Dialog v-model:visible="dialogDilazioniMail" modal header="Invia Mail PDF Lettera Accettazione" :style="{ width: '90vw' }">
    <div v-if="tempDilazioneMail" class="formgrid grid">
      <div class="field col-12 md:col-2">
        <label class="mr-2">Email/Pec</label>
        <prime-dropdown 
          v-model="tempDilazioneMail.type_comunication"
          :options="typesComunicationDilazione"
          optionLabel="label"
          optionValue="label"
          placeholder="Seleziona..." 
          class="inputfield w-full"
        />
      </div> 
      <div class="field col-12 md:col-5">
        <label for="email" class="mr-2">Invia a</label>
        <prime-dropdown 
          id="email" 
          v-model="tempDilazioneMail.cliente.email"
          :options="mailsDilazione"
          optionLabel="to"
          optionValue="to"
          placeholder="Seleziona..." 
          class="inputfield w-full"
          editable
        />
      </div> 
      <div class="field col-12 md:col-5">
        <label for="type_mail_dilazione" class="mr-2">Tipo Dilazione</label>
        <prime-dropdown 
          id="type_mail_dilazione" 
          v-model="tempDilazioneMail.type_mail_dilazione" 
          :options="typesMailDilazione"
          optionLabel="label"
          optionValue="label"
          placeholder="Seleziona..." 
          class="inputfield w-full"
        />
      </div>
      <!-- <div class="field col-12">
        <label class="mr-2">Relativo alle fatture:</label> <br>
        {{tempDilazioneMail.fatture.map(fattura => fattura.numero).join(",")}}
      </div> -->
    </div>
    <div v-else>
      Nessuna dilazione selezionata
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="dialogDilazioniMail = false" class="p-button-text p-button-secondary"/>
      <Button label="Invia" icon="pi pi-check" class="p-button-text" @click="sendMailDilazione" />
    </template>
  </Dialog>
  <Dialog v-model:visible="viewDialogDetailSignDilazione" modal header="Dettagli della richiesta di firma" :style="{ width: '50%' }">

    <div v-if="signDilazioneOptions.length > 1" class="col-12 mb-3">
      <label class="col-12 mb-2 block">Seleziona un contatto</label>

      <Dropdown
        v-model="selectedSignDilazioneOption"
        :options="signDilazioneOptions"
        optionLabel="label"
        placeholder="Seleziona un nominativo"
        class="w-full"
        @change="onSelectSignDilazioneOption"
      />
    </div>

    <div class="flex justify-content-around">
      <div class="col-12 md:col-4 flex flex-wrap">
        <label class="col-12">Nome e cognome</label>
        <InputText type="text" v-model="detailSignDilazione.nominativo"/>
      </div>
      <div class="col-12 md:col-4 flex flex-wrap">
        <label class="col-12">Email</label>
        <InputText type="text" v-model="detailSignDilazione.email"/>
      </div> 
      <div class="col-12 md:col-4 flex flex-wrap">
        <label class="col-12">Cellulare</label>
        <InputText type="text" v-model="detailSignDilazione.contatto"/>
      </div> 
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="viewDialogDetailSignDilazione = false" class="p-button-text p-button-secondary"/>
      <Button label="Invia" icon="pi pi-check" class="p-button-text" @click="sendSignRequestDilazione(detailSignDilazione)" :disabled="!detailSignDilazione.nominativo || !detailSignDilazione.contatto || !detailSignDilazione.email"/>
    </template>
  </Dialog>
  <Dialog v-model:visible="viewConfirmDeleteSignDilazione" modal header="Annulla la richiesta di firma" :style="{ width: '50%' }">
    <div class="formgrid grid">
      <h3>Vuoi annullare la richiesta di firma?</h3>
    </div>
    <template #footer>
      <Button label="No" icon="pi pi-times" @click="viewConfirmDeleteSignDilazione = false" class="p-button-text p-button-secondary"/>
      <Button label="Si" icon="pi pi-check" class="p-button-text" @click="sendDeleteSignRequestDilazione(detailSignDilazione)"/>
    </template>
  </Dialog>


</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/dilazioni-service'

import Loader from '@/components/Loader.vue'
import PrimeButton from 'primevue/button'
import PrimeInputText from 'primevue/inputtext'
import PrimeDropdown from 'primevue/dropdown'
import { useConfirm } from "primevue/useconfirm";

export default { 
  props: {
    clientIds: {
      type: Array,
      default: () => []
    },
    hideControls: {
      type: Boolean,
      default: false
    }
  },
  
  components: {
    Loader,
    PrimeButton,
    PrimeInputText,
    PrimeDropdown
  },

  data() {
    return {
      selectedSignDilazioneOption: null,
      signDilazioneOptions: [],
      allSignDilazioneOptions: [],
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      dataLoading: false,
      filter: '',
      clients:[],
      selectedClients: [],

      tempDilazioneMail: null,
      dialogDilazioniMail: false,
      dialogInviaBollettiniPostali: false,
      sendingBollettiniPostali: false,
      tempBollettiniPostali: null,
      mailsDilazione: [],
      allTypesMailDilazione: [
        {label:'Bonifico', for:['all', 'Cessata']},
        {label:'Bonifico Sdd', for:['all']},
        {label:'Titoli', for:['all']},
      ],
      typesMailDilazione: [],
      typesComunicationDilazione:[
        {'label':'email'},
        {'label':'pec'},
      ],
      type_state:[],
      data: {
        dilazioni: [],
        filtered: [],
      },
      view_all : false,
      isDisableSignPdf: false,
      isDisableDeleteSign: false,
      detailSignDilazione: {
        id: null,
        nominativo: null,
        contatto: null,
        email: null
      },
      viewDialogDetailSignDilazione: false,
      viewConfirmDeleteSignDilazione: false,
      types_stato: [
        {stato: null, type_data: null},
        {stato: 1, type_data: 'creazione', name: 'Documento creato'},
        {stato: 2, type_data: 'invio', name: 'Documento inviato'},
        {stato: 3, type_data: 'firma', name: 'Documento firmato'},
        {stato: 4, type_data: 'annullamento', name: 'Documento annullato'}
      ],
      user: JSON.parse(atob(localStorage.getItem('user'))).user[0],
      confirm: useConfirm()
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    this.getTypeStateDilazioni()
    
    if (!this.hideControls) {
      this.getClientHasDilazioni()
    } else if (this.clientIds && this.clientIds.length > 0) {
      this.selectedClients = this.clientIds.map(id => ({ id }));
      this.$nextTick(() => {
        this.getAllDilazioni();
      });
    }
  },
  
  watch: {
    filter(newVal) {
      this.applyFilter(newVal)
    },
    clientIds: {
      handler(newClientIds) {
        if (this.hideControls && newClientIds && newClientIds.length > 0 && this.service) {
          this.selectedClients = newClientIds.map(id => ({ id }));
          this.getAllDilazioni();
        }
      },
      immediate: false
    }
  },

  methods:{

    applySignDilazioneOption(option) {
      if (!option) {
        this.detailSignDilazione.nominativo = null
        this.detailSignDilazione.email = null
        this.detailSignDilazione.contatto = null
        return
      }

      this.detailSignDilazione.nominativo = option.nominativo ?? null
      this.detailSignDilazione.email = option.email ?? null
      this.detailSignDilazione.contatto = option.contatto ?? null
    },

    onSelectSignDilazioneOption(event) {
      const option = event.value

      this.applySignDilazioneOption(option)
    },

     getClientHasDilazioni(){
      this.dataLoading = true
      this.service.getClientHasDilazioni(this.view_all)
      .then((res) => {
        this.clients = res.items
      })
      .finally(() =>{
        this.dataLoading = false
      })
    },
    confirmDelete (event, dilazioneId) {
      this.confirm.require({
          target: event.currentTarget,
          message: 'Vuoi davvero eliminare la dilazione?',
          icon: 'pi pi-info-circle',
          rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
          acceptClass: 'p-button-danger p-button-sm',
          rejectLabel: 'No',
          acceptLabel: 'Si',
          accept: () => {
            this.onDeleteDilazione(dilazioneId)
            this.$toast.add({ severity: 'info', summary: 'Confermato', detail: 'Dilazione cancellata', life: 3000 });
          },
          reject: () => {
            // this.$toast.add({ severity: 'error', summary: 'Annullato', detail: 'You have rejected', life: 3000 });
          }
      });
    },

    onDeleteDilazione(dilazioneId){
      this.service.deleteDilazione(dilazioneId).then((res) => {
        if(res.success){
          this.data.dilazioni = this.data.dilazioni.filter( (el) => el.id != dilazioneId )

          this.applyFilter(this.filter)
          
          this.$eventBus.emit('dilazione-cancellata', {
            type: 'dilazione-cancellata',
            success: true,
            dilazioneId: dilazioneId
          })
        }
      })
    },

    onXmlRidDilazione(dilazioneId){
      this.service.downloadXmlRid(dilazioneId)
    },

    onPdfLetteraAccettazioneDilazione(dilazioneId){
      this.service.downloadPdfLetteraAccettazione(dilazioneId)
    },
    openDetailSignDilazione(dilazioneId){
      this.detailSignDilazione.id = dilazioneId
      this.detailSignDilazione.nominativo = null
      this.detailSignDilazione.contatto = null
      this.detailSignDilazione.email = null
      this.selectedSignDilazioneOption = null
      this.signDilazioneOptions = []

      const dilazione = this.data.filtered.find(item => item.id == dilazioneId)

      if (dilazione) {
        const numeriFattureDilazione = [
          ...new Set(
            (dilazione.fatture || []).map(fattura => fattura.numero).filter(Boolean)
          )
        ]

        this.signDilazioneOptions = this.allSignDilazioneOptions.filter(option =>
          numeriFattureDilazione.includes(option.fattura_numero)
        )

        if (this.signDilazioneOptions.length === 1) {
          this.selectedSignDilazioneOption = this.signDilazioneOptions[0]
          this.applySignDilazioneOption(this.signDilazioneOptions[0])
        }
      }

      this.viewDialogDetailSignDilazione = true
    },
    openConfirmDeleteSignDilazione(dilazioneId){
      this.detailSignDilazione.id = dilazioneId
      this.detailSignDilazione.nominativo = null
      this.detailSignDilazione.contatto = null
      this.detailSignDilazione.email = null
      this.viewConfirmDeleteSignDilazione = true
    },
    getDataStatusDilazione(dilazione){
      let type_data = 'data_' + (this.types_stato.find(type => type.stato == dilazione.cod_status_pratica).type_data)
      return dilazione[type_data]
    },
    sendSignRequestDilazione(detailDilazione){
      this.viewDialogDetailSignDilazione = false
      this.dataLoading = true
      this.isDisableSignPdf = true

      this.service.sendSignRequestDilazione(detailDilazione)
      .then((res)=> {
        
        let severity = res.items.success ? 'success' : 'error'
        let summary = res.items.success ? 'Successo' : 'Attenzione'
        let detail = res.items.errore == '' ? 'Richiesta di firma inviata correttamente' : res.items.errore
        
        this.$toast.add({severity:severity, summary: summary, detail:detail, life: 5000})
        if (!res.items.success) {
          this.isDisableSignPdf = false
        }else{
          this.setNewStatusPdfDilazione(detailDilazione.id, 2, res.items.cod_richiesta_firma)
        }
      })
      .finally(()=> {
        this.detailSignDilazione.id = null
        this.detailSignDilazione.nominativo = null
        this.detailSignDilazione.contatto = null
        this.detailSignDilazione.email = null
        this.selectedSignDilazioneOption = null
        this.dataLoading = false
      })
    },
    setNewStatusPdfDilazione(dilazioneId, newStatus, cod_richiesta_firma = null){      
      let dilazione_index = this.data.filtered.findIndex(item => item.id == dilazioneId)      
      if (dilazione_index != -1) {                
        let stato_documento = this.types_stato.find(stato => stato.stato == newStatus)
        
        this.data.filtered[dilazione_index][`data_${stato_documento.type_data}`] = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        this.data.filtered[dilazione_index].cod_status_pratica = newStatus
        this.data.filtered[dilazione_index].stato_documento = stato_documento.name
        if (cod_richiesta_firma) {
          this.data.filtered[dilazione_index].cod_richiesta_firma = cod_richiesta_firma
        }
        if (newStatus == 2) {
          this.data.filtered[dilazione_index].contatto = this.detailSignDilazione.contatto
          this.data.filtered[dilazione_index].email_firma = this.detailSignDilazione.email
          this.data.filtered[dilazione_index].nominativo = this.detailSignDilazione.nominativo
        }
      }
    },
    sendDeleteSignRequestDilazione(detailDilazione){
      this.viewConfirmDeleteSignDilazione = false
      this.dataLoading = true
      this.isDisableDeleteSign = true

      this.service.sendDeleteSignRequestDilazione(detailDilazione, this.user)
      .then((res)=> {
        let severity = res.items.error ? 'error' : 'success'
        let summary = res.items.error ? 'Attenzione' : 'Successo'
        let detail = res.items.response
        
        this.$toast.add({severity:severity, summary: summary, detail:detail, life: 5000})
        if (res.items.error) {
          this.isDisableDeleteSign = false
        }else{
          this.setNewStatusPdfDilazione(detailDilazione.id, 4)
        }
      })
      .finally(()=> {
        this.detailSignDilazione.id = null
        this.detailSignDilazione.nominativo = null
        this.detailSignDilazione.contatto = null
        this.detailSignDilazione.email = null
        this.selectedSignDilazioneOption = null
        this.dataLoading = false
      })
    },
    downloadPdf(dilazioneId, type_doc = 'dilazione'){
      this.service.downloadPdf(dilazioneId, type_doc)
    },
    changeStatusDilazione(dilazione, status){      
      this.dataLoading = true
      this.service.changeStatusDilazione(dilazione.id, status)
      .then((res) => {
        let severity = res.item.success ? 'success' : 'warn' 
        let detail = `${res.item.msg}`
        this.$toast.add({severity:severity, summary:'', detail: detail, life: 5000})
      })
      .finally(() =>{
        if (!this.view_all) {
          let id_filtered = this.data.filtered.findIndex(filter => filter.id == dilazione.id)
          this.data.filtered.splice(id_filtered, 1)
          if(this.selectedClients.length == 1){
            let id_cliente = dilazione.cliente.id
            let index = this.selectedClients.findIndex(client => client.id == id_cliente)
            this.selectedClients.splice(index, 1)
          }
        }else{
          let obj_status = this.type_state.find(type => type.id == status)

          dilazione.active = obj_status.id
          dilazione.color = obj_status.color
          dilazione.name_state = obj_status.name
        }
        this.dataLoading = false
      })

    },

    onBollettiniPostaliDilazione(dilazioneId){
      this.service.downloadBollettiniPostali(dilazioneId)
    },

    openDialogInviaBollettiniPostali(dilazione){
      const email = dilazione?.cliente?.email || dilazione?.email_firma || ''
      const numBollettini = Array.isArray(dilazione?.rate)
        ? dilazione.rate.length
        : (dilazione?.numero_rate || 0)

      this.tempBollettiniPostali = {
        id: dilazione.id,
        email,
        oggetto: 'Bollettini Postali',
        num_bollettini: numBollettini,
        body: [
          'Gentile Cliente,',
          '',
          'In allegato troverà i bollettini postali.',
          'Ogni bollettino contiene le informazioni necessarie per il pagamento della rata.',
          '',
          'Per qualsiasi necessità può fare riferimento a:',
          'Assistenza clienti: +39 080.246.05.10',
          'Email di supporto: assistenzaclienti@agfenergy.it',
          '',
          'Cordiali saluti.',
          'Il Team di AGF Energy.',
        ].join('\n'),
      }
      this.dialogInviaBollettiniPostali = true
    },

    confirmInviaBollettiniPostali(){
      if (!this.tempBollettiniPostali?.id || !this.tempBollettiniPostali?.email) {
        return
      }

      this.sendingBollettiniPostali = true
      this.dataLoading = true
      this.service.sendBollettiniPostaliDilazione(
        this.tempBollettiniPostali.id,
        this.tempBollettiniPostali.email
      )
      .then((res) => {
        const ok = res?.item?.success
        this.$toast.add({
          severity: ok ? 'success' : 'error',
          summary: ok ? 'Successo' : 'Errore',
          detail: res?.item?.message || (ok ? 'Bollettini inviati' : 'Errore nell\'invio dei bollettini'),
          life: 5000,
        })
        if (ok) {
          this.dialogInviaBollettiniPostali = false
          this.tempBollettiniPostali = null
        }
      })
      .finally(() => {
        this.sendingBollettiniPostali = false
        this.dataLoading = false
      })
    },

    openDialogMailDilazioni(dilazione){
      let searchTypeMail = dilazione.stato_fornitura == 'Cessata' ? 'Cessata' : 'all'
      
      this.typesMailDilazione = this.allTypesMailDilazione.filter(type => type.for.includes(searchTypeMail))

      this.addMailsToList(dilazione)
      this.tempDilazioneMail = dilazione
      this.dialogDilazioniMail = true
    },

    addMailsToList(dilazione){
      dilazione.type_comunication = 'email'
      this.mailsDilazione = []
      if ('cliente' in dilazione) {
        if ('email' in dilazione.cliente && dilazione.cliente.email != '') {
          this.mailsDilazione.push({to: dilazione.cliente.email})
        }
        if ('pec' in dilazione.cliente && dilazione.cliente.pec != '') {
          this.mailsDilazione.push({to: dilazione.cliente.pec})
        }
      }
    },

    sendMailDilazione(){
      this.dataLoading = true
      this.service.sendMailDilazione(this.tempDilazioneMail)
      .then((res) => {
         if (res.item) {
            this.$toast.add({severity: 'success', summary: 'Successo', detail: 'Email inviata', life: 3000});
          } else {
            this.$toast.add({severity: 'error', summary: 'Errore', detail: 'Errore nell\'invio della email', life: 3000});
          }
      })
      .finally(() =>{
        this.dataLoading = false
      })
    },
    /////

    navigateToTab(href){
      window.open(href, '_blank')
    },

    applyFilter(filter){
      const length = filter.trim().length
      if(length == 0){
        this.data.filtered = [...this.data.dilazioni]
        return
      }
      if(length > 2){
        this.data.filtered = this.data.dilazioni.filter( (el) => el.cliente.ragsoc.toUpperCase().indexOf(filter.toUpperCase()) >= 0 )
        return
      }
    },

    async getAllDilazioni() {
      if (this.selectedClients.length === 0 || !this.service) {
        return
      }

      this.dataLoading = true

      try {
        const res = await this.service.getAllDilazioni(this.selectedClients, this.view_all)
        const items = Array.isArray(res?.items) ? res.items : []

        if (!Array.isArray(res?.items)) {
          this.data.dilazioni = []
          this.data.filtered = []
          this.signDilazioneOptions = []
          this.allSignDilazioneOptions = []
          if (this.$toast) {
            this.$toast.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Impossibile caricare le dilazioni per questo cliente',
              life: 5000
            })
          }
          return
        }

        const processedDilazioni = items.map((el) => {
          el.type_mail_dilazione = this.allTypesMailDilazione[0].label

          let pagato = el.pagato
          el.rate = (el.rate || []).map((rata) => {
            pagato -= rata.importo
            rata.isPagato = (pagato >= -0.10)

            return rata
          })

          return el
        })

        const uniqueDilazioni = processedDilazioni.filter((dilazione, index, self) =>
          index === self.findIndex((d) => d.id === dilazione.id)
        )

        this.data.dilazioni = uniqueDilazioni
        this.data.filtered = [...this.data.dilazioni]

        const numeriFatture = [
          ...new Set(
            this.data.dilazioni.flatMap((dilazione) =>
              (dilazione.fatture || []).map((fattura) => fattura.numero).filter(Boolean)
            )
          )
        ]

        if (numeriFatture.length > 0) {
          const contattiRes = await this.service.getContattoByDilazione(numeriFatture)

          this.allSignDilazioneOptions = Object.values(
            (contattiRes.items || []).reduce((acc, item) => {
              acc[item.fattura_numero] = {
                fattura_numero: item.fattura_numero,
                label: item.fattura_numero + ' - ' + item.email,
                nominativo: item.nominativo,
                email: item.email,
                contatto: item.cellulare
              }
              return acc
            }, {})
          )
        } else {
          this.allSignDilazioneOptions = []
        }

        this.signDilazioneOptions = []
      } catch (err) {
        console.error('Errore in getAllDilazioni:', err)
        this.data.dilazioni = []
        this.data.filtered = []
        this.signDilazioneOptions = []
        this.allSignDilazioneOptions = []
      } finally {
        this.dataLoading = false
      }
    },

    getTypeStateDilazioni(){
      this.service.getTypeStateDilazioni()
      .then(res => {
        this.type_state = res.items        
      })
    }


  },

  computed:{
    
  },

}
</script>

<style scoped>
.box-center{
  text-align: center;
}
</style>